export const Bio = {
  name: "Azlaan Ranjha",
  roles: [
    "Electrical Engineer",
    "ML/AI Engineer",
    "PLC and SCADA Specialist",
    "Programmer",
    "Robotics Enthusiast",
    "Prompt Engineer",
    "Data Scientist",
    "Data Analyst",
    "Embedded Systems Expert",
    "PCB Designer",
    "MATLAB Expert",  
  ],
  description:
    "As an aspirational Electrical Engineering student at NUST, I am steadfast in my pursuit of a comprehensive understanding of cutting-edge technologies.",
  github: "https://github.com/Azlaan20",
  resume:
    "https://drive.google.com/file/d/1ax9Mhi---q93gnAoIwR8pioPFzN1gO8s/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
  kaggle: "https://www.kaggle.com/azlaanranjha",
  leetcode: "https://leetcode.com/azlaanranjha15/",
};

export const skills = [
  {
      title: "Data Science and Analytics",
      skills: [
        {
          name: "Python",
          image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MATLAB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/matlab/matlab-original.svg",
        },
        {
          name: "Microsoft Excel",
          image:
            "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/Excel_Logo.jpg?raw=true",
        },
      ],
  },
  {
      title: "ML and AI",
      skills: [
        {
          name: "Python",
          image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MATLAB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/matlab/matlab-original.svg",
        },
        {
          name: "Jupyter Notebook",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/jupyter/jupyter-original.svg",
        },
        {
          name: "Numpy",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/numpy/numpy-original.svg",
        },
        {
          name: "Pandas",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/pandas/pandas-original.svg",
        },
        {
          name: "PyTorch",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/pytorch/pytorch-original.svg",
        },
        {
          name: "TensorFlow",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/tensorflow/tensorflow-original.svg",
        },
        {
          name: "OpenCV",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/opencv/opencv-original.svg",
        },
        
      ],
  },
  {
      title: "Electronics and Embedded Systems",
      skills: [
          {
              name: "Proteus",
              image:
                "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/Proteus_Logo.png?raw=true",
          },
        {
          name: "LTSpice",
          image:
            "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/LTSpice_Logo.jpg?raw=true",
        },
        {
          name: "Altium Designer",
          image:
            "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/Altium_Designer_Logo.png?raw=true",
        },
        {
          name: "Arduino",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/arduino/arduino-original.svg",
        },
        {
          name: "Embedded C",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/embeddedc/embeddedc-original.svg",
        },
        {
          name: "MikroC Pro",
          image:
            "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/MikroC_Pro_Logo.jpg?raw=true",
        },
        {
          name: "MPLABX IDE",
          image:
            "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/MPLABX_Logo.png?raw=true",
        },
      ],
    },
    {
      title: "GUI Designing", 
      skills: [
          {
              name: ".NET Framework",
              image:
                "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg",
          },
          {
              name: "MATLAB",
              image:
                "https://raw.githubusercontent.com/devicons/devicon/master/icons/matlab/matlab-original.svg",
            },
      ],
    },
    {
      title: "Programming Languages",
      skills: [
          {
              name: "C",
              image:
                "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
          },
        {
          name: "C++",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
        },
        {
          name: "C#",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg",
        },
      ],
    },
  {
      title: "Cloud Computing",
      skills: [
          {
              name: "Google Cloud Platform",
              image:
                "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/Google_Cloud_Logo.png?raw=true",
          },
        {
          name: "IBM Cloud Platform",
          image:
            "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/IBM_Cloud_Logo.jpeg?raw=true",
        },
        {
          name: "AWS Cloud Platform",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original.svg",
        },
      ],
    },
  {
    title: "Frontend Development",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
          name: "WordPress",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/wordpress/wordpress-original.svg",
        },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
          name: "Putty",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/putty/putty-original.svg",
        },
      {
        name: "AutoCAD",
        image:
          "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/AutoCAD_Logo.png?raw=true",
      },
      {
          name: "X Code",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/xcode/xcode-original.svg",
        },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Canva",
        image:
          "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/Canva_Logo.png?raw=true",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/CodeClause_Logo.png?raw=true",
    role: "Artificial Intelligence Intern",
    company: "CodeClause",
    date: "Sep 2023 - Present",
    desc: "I am currently interning at CodeClause as an Artificial Intelligence Intern, working on projects like developing a spam classifier and a mask detection system, with the goal of completing at least two projects to earn a letter of recommendation.",
    skills: [
      "Artificial Intelligence",
      "Python",
      "Google Colab",
      "Jupyter Notebook",
      "PyCharm",
      "Kaggle",
      "Git",
      "Github",
      "Time Management",
      "Computer Vision",
    ],
    doc: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/documents/Offer-Letter/Offer%20Letter_page-0001.jpg",
  },
  {
    id: 1,
    img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/RAC_Logo.jpg?raw=true",
    role: "Team Associate - McLaren Competing Team",
    company: "Robotics and Automation Club - CEME NUST",
    date: "Sep 2023 - Present",
    desc: "I've recently joined McLaren's Robotic and Automation Club at CEME, NUST, aiming to contribute to cutting-edge robotics projects and competitions while staying updated with the latest advancements in the field.",
    skills: [
      "Robotics",
      "Automation",
      "Programming",
      "Innovation",
      "Collaboration",
    ],
  },
  {
      id: 1,
      img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/RAC_Logo.jpg?raw=true",
      role: "Team Associate of Biomedical Team",
      company: "Robotics and Automation Club - CEME NUST",
      date: "Sep 2023 - Present",
      desc: "I have recently become an Associate Member of both the McLaren Competing Team and the Biomedical Team within the Robotic and Automation Club at CEME, NUST, aiming to contribute my enthusiasm and dedication to robotics, automation, and healthcare-related projects.",
      skills: [
        "Automation",
        "Programming",
        "Robotics",
        "Innovation",
        "Collaboration",
      ],
    },
    {
      id: 1,
      img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/RAC_Logo.jpg?raw=true",
      role: "Team Associate of Artificial Intelligence Team",
      company: "Robotics and Automation Club - CEME NUST",
      date: "Sep 2023 - Present",
      desc: "I've recently joined CEME, NUST's Robotic and Automation Club as an Associate Member of the AI Team, aiming to explore the intersection of artificial intelligence and robotics for innovative automation solutions.",
      skills: [
        "AI & Robotics",
        "Collaboration",
        "Hands-on",
        "Learning",
        "Innovation",
      ],
    },
  {
    id: 2,
    img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/CodSoft_Logo.jpeg?raw=true",
    role: "Artificial Intelligence Intern",
    company: "CodSoft",
    date: "Aug 2023 - Present",
    desc: "Streamlining AI innovation through diverse projects and expertise in Python-based libraries, machine learning, and computer vision with NLP.",
    skills: [
      "Artificial Intelligence (AI)",
      "AI/ML Model Development",
      "Computer Vision",
      "OpenCV",
      "Data Visualization",
      "Data Manipulation",
      "Time Management",
    ],
    doc: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/documents/Artificial-Intelligence-Offer-Letter/Artificial%20Intelligence%20Offer%20Letter_page-0001.jpg",
  },
  {
      id: 2,
      img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/CodSoft_Logo.jpeg?raw=true",
      role: "Machine Learning Intern",
      company: "CodSoft",
      date: "Aug 2023 - Present",
      desc: "As a Machine Learning Intern, I've tackled diverse projects from customer churn prediction to movie genre classification, refining my skills and bridging theory and practice in the AI domain.",
      skills: [
        "Machine Learning (ML)",
        "AI/ML Model Development",
        "TensorFlow",
        "Keras",
        "Data Visualization",
        "Data Manipulation",
        "Deep Learning",
        "Neural Networks",
        "Time Management",
      ],
      doc: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/documents/Machine-Learning-Offer-Letter/Machine%20Learning%20Offer%20Letter_page-0001.jpg",
    },
  {
    id: 3,
    img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/Logo-Yokogawa.jpg?raw=true",
    role: "Engineering Intern",
    company: "Yokogawa",
    date: "July 2023 - Sep 2023",
    desc: "Interned at Yokogawa, gaining valuable knowledge in PLCs, SCADA, RTU systems, and HMI technology while appreciating the company's contributions to industrial automation.",
    skills: [
      "Electronics",
      "Circuit Design",
      "Electrical Engineering",
      "Programmable Logic Controllers (PLC)",
      "SCADA",
      "Distribution Control Systems (DCS)",
      "Human Machine Interface (HMI)",
      "Remote Terminal Units (RTU)",
      "Time Management",
      "Collaboration",
      "Leadership",
    ],
  },
  {
    id: 4,
    img: "https://raw.githubusercontent.com/Azlaan20/azlaanranjha.github.io/main/icons/Quantium_Logo.png?raw=true",
    role: "Data Analytics Virtual Intern",
    company: "Quantium",
    date: "Jul 2023 - Aug 2023",
    desc: "Participated in a Quantium virtual program, acquiring hands-on data analytics skills, solving real business problems, and receiving mentorship from industry professionals.",
    skills: [
      "Data Science and Analytics",
      "Data Visualisation",
      "Data Manipulation",
      "Data Analysis",
      "Time Management",
    ],
    doc: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/documents/Quantium_Data%20Analytics%20Virtual%20Programme_Completion_Certificate.pdf",
  },
  {
      id: 5,
      img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/NUSTAG%20Logo.jpeg?raw=true",
      role: "AV Team Member",
      company: "NUSTAG",
      date: "Sep 2022 - Present",
      desc: "Technical team member at NUST Automotive Group's autonomous vehicle project, specializing in ROS, Carla, computer vision, LiDAR, and electronic self-driving formula racing cars.",
      skills: [
        "ROS",
        "Carla",
        "Computer Vision",
        "LiDAR",
        "Python",
        "Autonomous Driving Algorithms",
        "Electronic Control Systems",
        "Software Development",
      ],
    },
];

export const education = [
  {
    id: 0,
    img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/NUST%20Logo.jpeg?raw=true",
    school: "National University of Sciences and Technology (NUST)",
    date: "Nov 2021 - Aug 2025",
    grade: "3.25 CGPA",
    desc: "I am currently pursuing a Bachelor's in Electrical Engineering at NUST College of EME, Rawalpindi. I have completed 4 semesters and have a CGPA of 3.25/4.00.",
    degree: "Bachelor of Engineering - BE, Electrical Engineering",
  },
  {
    id: 1,
    img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/icons/Beaconhouse%20Logo.jpeg?raw=true",
    school: "Beaconhouse School System, Sargodha Campus",
    date: "Sep 2006 - Jul 2019",
    grade: "5 A* and 4 A in O levels. 1 A* 3 A and 2 B in A levels",
    desc: "Engaged in various extracurricular activities including debating, humanitarian, literary societies, cricket, football teams, and serving as Assistant Headboy.",
    degree: "O-Levels and A-Levels",
  },
];

export const projects = [
  {
    id: 9,
    title: "Chatbot with Rule-Based Responses Project",
    date: "Aug 2023 - Sep 2023",
    description:
      "Developed a foundational chatbot project using OpenAI to respond to user inputs, collaborating on rule definition and ensuring coherent conversation flow.",
    tags: [
      "Chatbot Development",
      "OpenAI",
      "Natural Language Processing",
      "Python",
      "Conversation Flow",
      "Rule Definition",
      "Iterative Testing",
      "Collaboration",
    ],
    category: "Chat Bot",
    github: "https://github.com/Azlaan20/CODSOFT/tree/main/Response-Based%20Chatbot",
    member: [
      {
        name: "Azlaan Ranjha",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
        linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
      },
      ],
  },
  {
    id: 0,
    title: "Face Detection and Recognition Application Project",
    date: "Aug 2023 - Sep 2023",
    description:
      "Developed an AI application for robust face detection and recognition, integrating gender and emotion classification using pre-trained models, showcasing expertise in computer vision and deep learning.",
    tags: ["AI application", "Face detection and recognition", "Deep learning", "Gender classification", "Emotion recognition", "Computer vision"],
    category: "Computer Vision and AI Application Development",
    github: "https://github.com/Azlaan20/CODSOFT/tree/main/Face%20Detection%20and%20Recognition",
    member: [
      {
        name: "Azlaan Ranjha",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
        linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
        github: "https://github.com/Azlaan20",
      },
    ],
  },
  {
    id: 1,
    title: "Recommendation System Project",
    date: "Aug 2023 - Sep 2023",
    description:
      "Developed an intuitive recommendation system using collaborative and content-based filtering techniques, demonstrating proficiency in tailoring recommendations to user preferences across diverse domains.",
    tags: ["Recommendation System", "Collaborative Filtering", "Content-Based Filtering", "User Preferences", "User Interface Design", "Python"],
    category: "Recommendation System Development and User Preferences Analysis",
    github: "https://github.com/Azlaan20/CODSOFT/tree/main/Movie%20Recommendation%20System",
    member: [
      {
        name: "Azlaan Ranjha",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
        linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
      },
      ],
  },
  {
    id: 2,
    title: "Tic-Tac-Toe AI Implementation Project",
    date: "Aug 2023 - Sep 2023",
    description:
      "Created an intelligent Tic-Tac-Toe AI using the Minimax algorithm, showcasing proficiency in game theory and search algorithms, and providing an engaging gaming experience.",
    tags: ["Tic-Tac-Toe", "AI Agent", "Minimax Algorithm", "Game Theory", "Search Algorithms", "User Interface Design", "Python"],
    category: "AI Game Development and Game Theory",
    github: "https://github.com/Azlaan20/CODSOFT/tree/main/Tic%20Tac%20Toe%20Game",
    member: [
      {
        name: "Azlaan Ranjha",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
        linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
      },
      ],
  },
  {
    id: 3,
    title: "Building Video AI Applications at the Edge on Jetson Nano",
    date: "Aug 2023 - Aug 2023",
    description:
      "Leveraged NVIDIA Jetson Nano and DeepStream SDK for AI video applications, acquiring hands-on skills and certification, ready for future Edge projects.",
    tags: ["NVIDIA Jetson Nano", "JupyterLab", "Python", "Deep Learning", "Video Analytics", "Edge Computing", "Computer Vision", "Data Manipulation", "Neural Networks", "Time Management"],
    category: "AI Video Analytics and Edge Computing",
  },
  {
    id: 10,
    title: "Computer Vision - Image Basics with OpenCV and Python",
    date: "Aug 2023 - Aug 2023",
    description:
      "Developed fundamental computer vision skills, including image manipulation and annotation, using OpenCV and Python, laying a strong foundation for practical applications.",
    tags: ["Computer Vision", "OpenCV", "Python", "Image Manipulation", "Image Annotation", "Foundational Skills", "Practical Applications", "Machine Learning", "AI Ethics"],
    category: "Computer Vision and Image Processing Fundamentals",
  },
  {
    id: 4,
    title: "Credit Card Fraud Detection Project",
    date: "Aug 2023 - Aug 2023",
    description:
      "Developed an advanced credit card fraud detection model utilizing Logistic Regression, Decision Trees, and Random Forests, showcasing expertise in machine learning and data preprocessing in the context of financial security.",
    tags: ["Credit Card Fraud Detection", "Machine Learning", "Logistic Regression", "Decision Trees", "Random Forests", "Data Preprocessing", "Financial Security"],
    category: "Financial Security and Fraud Detection",
    github: "https://github.com/Azlaan20/CODSOFT/tree/main/Credit%20Card%20Fraud",
  },
  {
    id: 5,
    title: "Customer Churn Prediction Project",
    date: "Aug 2023 - Aug 2023",
    description:
      "Developed a predictive customer churn model using Logistic Regression, Random Forests, and Gradient Boosting, demonstrating proficiency in data-driven insights and predictive modeling for customer retention strategies.",
    tags: ["Customer Churn Prediction", "Predictive Modeling", "Logistic Regression", "Random Forests", "Gradient Boosting", "Feature Engineering", "Data Analysis"],
    category: "Customer Churn Prediction and Predictive Modeling",
    github: "https://github.com/Azlaan20/CODSOFT/tree/main/Customer%20Churn%20Prediction",
  },
  {
    id: 6,
    title: "Developed a Cell Classification Model using Support Vector Machines (SVM) to Predict Tumor Types",
    date: "Aug 2023 - Aug 2023",
    description:
      "Conducted data preprocessing and utilized SVM with RBF kernel for tumor classification, employing evaluation metrics to assess model performance.",
    tags: ["Data Preprocessing", "Data Visualization", "SVM", "RBF Kernel", "Machine Learning", "Model Evaluation"],
    category: "Tumor Classification and Machine Learning",
  },
  {
    id: 7,
    title: "Disaster Risk Monitoring Using Satellite Imagery",
    date: "Aug 2023 - Aug 2023",
    description:
      "Completed an immersive project with the NVIDIA Deep Learning Institute, acquiring skills in using satellite imagery for disaster risk monitoring and deep learning model construction, in collaboration with UNOSAT.",
    tags: ["Satellite Imagery", "Deep Learning", "Disaster Risk Monitoring", "Data Manipulation", "Neural Networks", "Machine Learning", "Python", "AI Ethics"],
    category: "Satellite Imagery Analysis and Deep Learning",
  },
  {
    id: 8,
    title: "Emotion AI: Facial Key-Points Detection",
    date: "Aug 2023 - Aug 2023",
    description:
      "Developed a robust image classification model using convolutional and residual neural networks in Keras and TensorFlow, enhancing accuracy and gaining practical expertise in deep learning.",
    tags: ["Image Classification", "Convolutional Neural Networks", "Residual Neural Networks", "Keras", "TensorFlow", "Data Augmentation", "Dropout Regularization", "Deep Learning", "Neural Networks"],
    category: "Image Classification and Deep Learning Model Development",
  },
  {
      id: 11,
      title: "Generative Adversarial Network (GAN) Implementation for Handwritten Digit Generation",
      date: "Aug 2023 - Aug 2023",
      description:
        "Developed Generative Adversarial Networks (GANs) using PyTorch, honing hands-on skills in GAN implementation for lifelike handwritten digit generation.",
      tags: ["Generative Adversarial Networks", "GANs", "PyTorch", "Convolutional Neural Networks", "Optimization Algorithms"],
      category: "Generative Adversarial Networks (GANs) and PyTorch Implementation",
  },
  {
      id: 12,
      title: "Getting Started with AI on Jetson Nano",
      date: "Aug 2023 - Aug 2023",
      description:
        "Embraced an immersive robotics course with the NVIDIA Jetson Nano Developer Kit, gaining hands-on experience and mastering neural networks for diverse AI and robotics tasks.",
      tags: ["NVIDIA Jetson Nano", "Robotics", "AI", "Neural Networks", "Deep Learning", "Computer Vision", "OpenCV", "Image Processing"],
      category: "AI and Robotics with NVIDIA Jetson Nano",
  },
  {
      id: 13,
      title: "Hand-Written Digit Classification using TensorFlow",
      date: "Aug 2023 - Aug 2023",
      description:
        "Engaged in a project-centric course, mastering Keras and TensorFlow for image classification, gaining hands-on experience, and boosting confidence in diverse image classification tasks.",
      tags: ["Keras", "TensorFlow", "Image Classification", "Neural Networks", "Deep Learning"],
      category: "Image Classification with Keras and TensorFlow",
  },
  {
      id: 14,
      title: "Image Classification to Classify Images of Cats and Dogs using Transfer Learning",
      date: "Aug 2023 - Aug 2023",
      description:
        "Employed TensorFlow and Keras for image classification, achieving a remarkable 96% validation data accuracy, while mastering Convolutional Neural Networks (CNNs) and overfitting mitigation techniques.",
      tags: ["TensorFlow", "Keras", "Image Classification", "Convolutional Neural Networks", "Data Augmentation", "Dropout Regularization"],
      category: "Image Classification with Keras and TensorFlow",
  },
  {
      id: 15,
      title: "Image Classification with Convolutional Neural Networks using Keras",
      date: "Aug 2023 - Aug 2023",
      description:
        "Focused on mastering Convolutional Neural Networks (CNNs) in the Keras framework with TensorFlow, tackling image classification challenges using a subset of the CIFAR-10 dataset with guidance and mentorship on the Coursera Rhyme platform.",
      tags: ["Machine Learning", "Python", "AI/ML Model Deployment", "Image Processing", "TensorFlow", "Keras", "Data Manipulation", "Deep Learning", "Neural Networks", "Time Management", "AI Ethics"],
      category: "Image Classification with Keras and TensorFlow",
  },
  {
      id: 16,
      title: "Movie Genre Classification Project",
      date: "Aug 2023 - Aug 2023",
      description:
        "Developed an innovative machine learning model for movie genre prediction using advanced techniques like TF-IDF, word embeddings, and top-tier classifiers, showcasing expertise in merging textual analysis and machine learning.",
      tags: ["Machine Learning", "Text Classification", "Natural Language Processing", "TF-IDF", "Word Embeddings", "Naive Bayes", "Logistic Regression", "Support Vector Machines"],
      category: "Machine Learning",
      github: "https://github.com/Azlaan20/CODSOFT/tree/main/Movie%20Genre%20Classification",
  },
  {
      id: 17,
      title: "Predict Baby Weight with TensorFlow on AI Platform",
      date: "Aug 2023 - Aug 2023",
      description:
        "Established infrastructure and operational framework using Google Cloud Services and Jupyter Notebook, focused on precise baby weight prediction, enabled dynamic model building, employed BigQuery for advanced data evaluation, and achieved success meeting operational criteria. Skills include ML, Python, AI/ML model deployment, TensorFlow, data manipulation, deep learning, neural networks, and time management.",
      tags: ["Machine Learning", "Python", "AI/ML Model Deployment", "TensorFlow", "Data Manipulation", "Deep Learning", "Neural Networks", "Time Management"],
      category: "Machine Learning and Data Science",
  },
  {
      id: 18,
      title: "Sales Data Analysis and Categorization",
      date: "Aug 2023 - Aug 2023",
      description:
        "Conducted extensive data analysis in the retail sector using Python and a variety of data analysis tools to gain deep insights into customer behaviors and preferences, showcasing proficiency in data analysis, visualization, and problem-solving for tangible business benefits.",
      tags: ["Data Analysis", "Data Cleaning", "Data Visualization", "Statistical Analysis", "Retail Sector", "Python", "Data Exploration", "Customer Behavior", "Data Preprocessing", "Machine Learning", "Deep Learning", "Neural Networks", "Time Management"],
      category: "Data Analysis and Machine Learning",
      github: "https://github.com/Azlaan20/Quantium-Internship",
  },
  {
      id: 19,
      title: "Spam SMS Detection Project",
      date: "Aug 2023 - Aug 2023",
      description:
        "Implemented an advanced AI project for SMS classification, using TF-IDF, word embeddings, and machine learning models like Naive Bayes, Logistic Regression, and SVM to effectively detect spam messages.",
      tags: ["Machine Learning", "Text Classification", "Natural Language Processing", "TF-IDF", "Word Embeddings", "Naive Bayes", "Logistic Regression", "Support Vector Machines"],
      category: "Artificial Intelligence (AI) Project for SMS Classification",
      github: "https://github.com/Azlaan20/CODSOFT/tree/main/SMS%20Spam%20Detection",
  },
  {
      id: 20,
      title: "Using MATLAB for Data Analytics using Historical Baseball Data",
      date: "Aug 2023 - Aug 2023",
      description:
        "Developed expertise in data analysis, visualization, and insights extraction using MATLAB, employing statistical techniques, precise data filtering, and immersive visualizations to enhance skills in data science and analytics.",
        Tags: ["Data Science", "Data Analysis", "Data Visualization", "MATLAB", "Statistical Techniques", "Data Filtering", "Skills Enhancement", "Machine Learning", "Text Classification", "Natural Language Processing", "TF-IDF", "Word Embeddings", "Naive Bayes", "Logistic Regression", "Support Vector Machines"],
      category: "Data Science and Analytics",
  },
  {
      id: 21,
      title: "Q-Learning Algorithm Based Hand Cricket Game",
      date: "Jul 2023 - Jul 2023",
      description:
        "Engage in thrilling Hand Cricket matches against advanced AI with strategic decision-making, Q-learning integration, and immersive commentary.",
      tags: ["Artificial Intelligence", "Reinforcement Learning", "AdvancedAI", "Hand Cricket", "Gameplay Dynamics", "Commentary Immersion", "Sports and Technology"],
      category: "Gaming and Artificial Intelligence",
      github: "https://colab.research.google.com/drive/10yLUxfuDI-FgCJdZvwAKTNZXqiQfmrPk?usp=sharing",
  },
  {
      id: 22,
      title: "Sensor-Array Based Line Follower Robot (Arduino UNO)",
      date: "Jul 2023 - Jul 2023",
      description:
        "Team Dedication excelled in the National Engineering Robotics Competition by collaboratively building and coding a Line-Follower Robot, overcoming challenges, optimizing sensors, and enhancing competitive readiness.",
      tags: ["Robotics", "Engineering Competition", "Line-Follower Robot", "Coding", "Teamwork", "Leadership", "Microcontroller Programming", "Embedded Systems", "Team Management"],
      category: "Robotics and Engineering Achievement",
      github: "https://github.com/Azlaan20/Arduino_Self_Driving_Car",
      member: [
          {
            name: "Azlaan Ranjha",
            img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
            linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
          },
          {
              name: "Laiba Jabbar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Laiba_Jabbar.jpeg?raw=true", 
              linkedin: "https://www.linkedin.com/in/laiba-jabbar-aa1a19233/",
          },
          {
              name: "Muneeb Arshad",
              img:"https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Muneeb_Arshad.jpeg?raw=true",
              linkedin: "https://www.linkedin.com/in/muneeb-arshad-75a586273/",
          }
      ],
  },
  {
      id: 23,
      title: "Active First-Order Op-Amp RC Band Pass Filter",
      description:
        "Designed and simulated a bandpass filter with 12 dB gain and a 3 dB bandwidth from 500 Hz to 10 kHz using LM741 Op-Amp and Multisim software, combining low-pass and high-pass circuits for precise frequency control and validation.",
      tags: ["Electronics", "Frequency Control", "Circuit Simulation","Teamwork", "Leadership", "Project Management", "Time Management"],
      category: "Electronics and Circuit Design",        
      member: [
          {
            name: "Azlaan Ranjha",
            img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
            linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
          },
          {
              name: "Laiba Jabbar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Laiba_Jabbar.jpeg?raw=true", 
              linkedin: "https://www.linkedin.com/in/laiba-jabbar-aa1a19233/",
          },
      ],
  },
  {
      id: 24,
      title: "Arithmetic Logic Unit",
      description:
        " Led a collaborative effort to create a versatile 16-function Arithmetic Logic Unit (ALU) with a 4-bit operand range, utilizing CMOS family chips for physical implementation, and managed a team of three members with expertise in electronics, circuit design, electrical engineering, leadership, teamwork, project management, and time management.",
      tags: ["Electronics", "Circuit Design", "Electrical Engineering", "Proteus Simulation", "Circuit Simulation", "Component Selection", "Validation", "Teamwork", "Leadership", "Project Management", "Time Management"],
      category: "Electronics and Circuit Design",        
      member: [
          {
            name: "Azlaan Ranjha",
            img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
            linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
          },
          {
              name: "Bilal Younas Chaudhary",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Bilal_Younas_Chaudhary.jpeg?raw=true", 
              linkedin: "https://www.linkedin.com/in/bilal-younas-chaudhary-069a22254/",
          },
          {
              name: "Rana Abdullah Azhar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
              linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
          },
      ],
  },
  {
      id: 25,
      title: "C++ Crossword Puzzle Game with Random Puzzle Generation",
      description:
        "Created an engaging C++ Crossword Puzzle Game with dynamic gameplay, word submission, comprehensive multi-directional word search, and interactive outcome indicators.",  
      tags: ["C++", "Crossword Puzzle Game", "Dynamic Gameplay", "Word Submission", "Comprehensive Word Search", "Interactive Indicators", "Leadership", "Teamwork", "Project Management", "Time Management"],
      category: "Programming Projects",      
      member: [
          {
            name: "Azlaan Ranjha",
            img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
            linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
          },
          {
              name: "Rana Abdullah Azhar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
              linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
          },
      ],
  },
  {
      id: 26,
      title: "Fixed and Variable Channel Power Supply",
      description:
        "The project aims to create a versatile and efficient dual-channel power supply with fixed and variable voltage options, each providing 1A of continuous current, in a compact design, suitable for a wide range of electronic applications, featuring precise voltage control and user-friendly interface.",
      tags: ["Power Supply", "Electronics", "Circuit Design", "Electrical Engineering", "PCB Design", "Leadership", "Team Management", "Project Management", "Time Management"],
      category: "Electronics and Circuit Design",   
      member: [
          {
            name: "Azlaan Ranjha",
            img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
            linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
          },
          {
              name: "Bilal Younas Chaudhary",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Bilal_Younas_Chaudhary.jpeg?raw=true", 
              linkedin: "https://www.linkedin.com/in/bilal-younas-chaudhary-069a22254/",
          },
          {
              name: "Rana Abdullah Azhar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
              linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
          },
      ],
  },
  {
      id: 27,
      title: "Multi-Function Evaluator using PIC18F452",
      description:
        "An embedded masterpiece featuring the potent PIC18F452 microcontroller, excelling in numeric manipulation, multiplayer Tic Tac Toe gaming, AC sine wave generation, personalized security with a 4-digit PIN, efficient keypad input, crystal-clear LCD output, and expert use of MPLABX and MicroC Pro, with a quick reboot option.",
      tags: ["PIC18F452", "Embedded Systems", "Microcontroller Programming", "Electronics", "Circuit Design", "Electrical Engineering", "MicroC Pro", "MPLAB X", "Leadership", "Team Management", "Project Management", "Time Management"],
      category: "Embedded Systems and Microcontroller Programming",   
      member: [
          {
            name: "Azlaan Ranjha",
            img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
            linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
          },
          {
              name: "Bilal Younas Chaudhary",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Bilal_Younas_Chaudhary.jpeg?raw=true", 
              linkedin: "https://www.linkedin.com/in/bilal-younas-chaudhary-069a22254/",
          },
          {
              name: "Rana Abdullah Azhar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
              linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
          },
      ],
  },
  {
      id: 28,
      title: "Mutual Inductance Metal Detector",
      description:
        "Innovatively designed a Metal Detector Circuit utilizing Mutual Inductance, implemented on a PCB for robust and accurate metal detection, validated through rigorous testing.",
      tags: ["Metal Detector", "Mutual Inductance", "Electronics", "Circuit Design", "Electrical Engineering", "PCB Design", "Innovative Design", "Robust Detection", "Accurate Sensing", "Functional Validation", "Time Management"],
      category: "Electronics and Circuit Design",   
  },
  {
      id: 29,
      title: "Self-Made 5V Constant Voltage Regulator Circuit",
      description:
        "Engineered a versatile 5V voltage regulator circuit with precise control, resilience to input variations, and real-world applicability through the integration of BJTs, Op-Amps, resistors, capacitors, and potentiometers.",
      tags: ["Voltage Regulator Circuit", "Electronics", "Circuit Design", "Electrical Engineering", "BJT", "Op-Amp", "Component Integration", "Voltage Stability", "Resilient Output", "Practical Efficacy", "Time Management"],
      category: "Electronics and Circuit Design",   
      member: [
          {
            name: "Azlaan Ranjha",
            img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
            linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
          },
          {
              name: "Bilal Younas Chaudhary",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Bilal_Younas_Chaudhary.jpeg?raw=true", 
              linkedin: "https://www.linkedin.com/in/bilal-younas-chaudhary-069a22254/",
          },
          {
              name: "Rana Abdullah Azhar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
              linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
          },
      ],
  },
  {
      id: 30,
      title: "USB supporting Media Player with Video Support using C++ (with GUI)",
      description:
        "Developed a C++ program for drive connection analysis, storage capacity assessment, media sorting and playback, playlist management, and modern GUI design with video playback limitations in mind.",
      tags: ["Media Player", "C++", "GUI", "Drive Detection", "Storage Assessment", "Media Sorting", "Playback Engine", "Playlist Management", "User-Friendly GUI", "Video Playback Limitation", "Project Management", "Time Management"],
      category: "Programming Projects",   
      github: "https://github.com/Azlaan20/GUI-Based-Music-Player",
      member: [
          {
            name: "Azlaan Ranjha",
            img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
            linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
          },
          {
              name: "Laiba Jabbar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Laiba_Jabbar.jpeg?raw=true", 
              linkedin: "https://www.linkedin.com/in/laiba-jabbar-aa1a19233/",
          },
          {
              name: "Rana Abdullah Azhar",
              img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
              linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
          },
      ],
  },

  {
    id: 31,
    title: "Transistor-Based Discrete Audio Amplifier",
    description:
      "Designed and constructed a discrete audio amplifier circuit with a transistor-based design, achieving high-quality audio amplification and precise control over gain and frequency response.",
    tags: ["Audio Amplifier", "Electronics", "Circuit Design", "Electrical Engineering", "Transistor-Based Design", "High-Quality Amplification", "Gain Control", "Frequency Response", "Time Management"],
    category: "Electronics and Circuit Design",
    member: [
      {
        name: "Azlaan Ranjha",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
        linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
      },
      {
          name: "Laiba Jabbar",
          img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Laiba_Jabbar.jpeg?raw=true", 
          linkedin: "https://www.linkedin.com/in/laiba-jabbar-aa1a19233/",
      },
      {
          name: "Rana Abdullah Azhar",
          img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
          linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
      },
      {
        name: "Bilal Younas Chaudhary",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Bilal_Younas_Chaudhary.jpeg?raw=true", 
        linkedin: "https://www.linkedin.com/in/bilal-younas-chaudhary-069a22254/",
      },
  ],
  },

  {
    id: 32,
    title: "Single-Phase Multi-Tap Step Up Transformer",
    description:
      "Designed and constructed a single-phase multi-tap step-up transformer with a variable turns ratio, achieving precise voltage control and efficient power transmission.",
    tags: ["Transformer", "Electrical Engineering", "Circuit Design", "Voltage Control", "Power Transmission", "Time Management"],
    category: "Electrical Engineering and Transformer Design",
    member: [
      {
        name: "Azlaan Ranjha",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
        linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
      },
      {
          name: "Laiba Jabbar",
          img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Laiba_Jabbar.jpeg?raw=true", 
          linkedin: "https://www.linkedin.com/in/laiba-jabbar-aa1a19233/",
      },
      {
          name: "Rana Abdullah Azhar",
          img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
          linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
      },
      {
        name: "Bilal Younas Chaudhary",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Bilal_Younas_Chaudhary.jpeg?raw=true", 
        linkedin: "https://www.linkedin.com/in/bilal-younas-chaudhary-069a22254/",
      },
  ],
  },

  {
    id: 33,
    title: "MATLAB-Based Dynamic Audio Equaliser",
    description:
      "Developed a dynamic audio equaliser using MATLAB, achieving precise control over frequency response and audio quality enhancement.",
    tags: ["Audio Equaliser", "MATLAB", "Audio Quality Enhancement", "Frequency Response", "Time Management"],
    category: "Audio Engineering and MATLAB",
    member: [
      {
        name: "Azlaan Ranjha",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
        linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
      },
      {
          name: "Laiba Jabbar",
          img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Laiba_Jabbar.jpeg?raw=true", 
          linkedin: "https://www.linkedin.com/in/laiba-jabbar-aa1a19233/",
      },
      {
          name: "Rana Abdullah Azhar",
          img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
          linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
      },
      {
        name: "Bilal Younas Chaudhary",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Bilal_Younas_Chaudhary.jpeg?raw=true", 
        linkedin: "https://www.linkedin.com/in/bilal-younas-chaudhary-069a22254/",
      },
  ],
  },

  {
    id: 34,
    title: "Battery Management System",
    description:
      "Designed and constructed a battery management system with precise voltage control and efficient power distribution.",
    tags: ["Battery Management", "Electrical Engineering", "Circuit Design", "Voltage Control", "Power Distribution", "Time Management"],
    category: "Electrical Engineering and Battery Management",
    member: [
      {
        name: "Azlaan Ranjha",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/src/images/HeroImage.jpg?raw=true",
        linkedin: "https://www.linkedin.com/in/azlaan-ranjha-1b023a107/",
      },
      {
          name: "Laiba Jabbar",
          img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Laiba_Jabbar.jpeg?raw=true", 
          linkedin: "https://www.linkedin.com/in/laiba-jabbar-aa1a19233/",
      },
      {
          name: "Rana Abdullah Azhar",
          img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Rana_Abdullah_Azhar.jpeg?raw=true",  
          linkedin: "https://www.linkedin.com/in/abdullah-azhar-476699235/",
      },
      {
        name: "Bilal Younas Chaudhary",
        img: "https://github.com/Azlaan20/azlaanranjha.github.io/blob/main/members/Bilal_Younas_Chaudhary.jpeg?raw=true", 
        linkedin: "https://www.linkedin.com/in/bilal-younas-chaudhary-069a22254/",
      },
  ],
  }
];

export const TimeLineData = [
  { year: 2016, text: "Started my O-Levels" },
  { year: 2019, text: "A-Levels Education" },
  { year: 2021, text: "Admission in Electrical Engineering in NUST College of EME" },
  { year: 2023, text: "Did Multiple Internships, Projects and many online certifications. Also participated in many competitions and events." },
];
